import React from "react";
import { Container } from "react-bootstrap";
import InstaIframe from "../../../InstaIframe";

const SocialMedia = () => {
  return (
    <div className="instafeed text-center">
      <div className="main_heading mb-4">
        <h2 class="title30">Get a Tour of our Social Media</h2>
      </div>
      <h5 class="subtitle text-center mb-3">
        {" "}
        Follow{" "}
        <a
          href="https://www.instagram.com/belgium_webnet/"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          @Belgium Webnet
        </a>
        on Instagram to get inspired
      </h5>
      <InstaIframe />
    </div>
  );
};

export default SocialMedia;
